import React, { useState } from 'react'
import Step1 from '../Calculator/Step1';
import Step2 from '../Calculator/Step2';
import Step3 from '../Calculator/Step3';
import Step4 from '../Calculator/Step4';
import Step5 from '../Calculator/Step5';
import Step6 from '../Calculator/Step6';
import Step7 from '../Calculator/Step7';
import Step8 from '../Calculator/Step8';
import Step9 from '../Calculator/Step9';
import Step10 from '../Calculator/Step10';
import Step11 from '../Calculator/Step11';
import Step12 from '../Calculator/Step12';
import Contact from '../Calculator/Contact';


export default function StepForm(props) {
  const [currentStep, setCurrentStep] = useState(1)
  const totalSteps = 12;

  const prevStep = (step) => {
    setCurrentStep(step - 1)
  }

  const nextStep = (step) => {
    setCurrentStep(step + 1)
  }

  const steps = () => {
    switch (currentStep) {
      case 1:
        return (
          <Step1
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.taxDebtType}
          />
        )
      case 2:
        return (
          <Step2
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.totalDebt}
          />
        )
      case 3:
        return (
          <Step3
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.unfiledTaxReturns}
          />
        )
      case 4:
        return (
          <Step4
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.taxDebtKind}
          />
        )
      case 5:
        return (
          <Step5
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.grossMonthlyIncome}

          />
        )
      case 6:
        return (
          <Step6
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.creditScore}

          />
        )
      case 7:
        return (
          <Step7
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.enrollmentPlan}
          />
        )
      case 8:
        return (
          <Step8
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.firstName}
          />
        )
      case 9:
        return (
          <Step9
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.lastName}
          />
        )
      case 10:
        return (
          <Step10
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.email}
          />
        )
      case 11:
        return (
          <Step11
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            value={props.dataArray.cellPhone}
          />
        )
      case 12:
        return (
          <Step12
            prevStep={prevStep}
            nextStep={nextStep}
            updateFieldValue={props.updateFieldValue}
            firstName={props.dataArray.firstName}
            lastName={props.dataArray.lastName}
            email={props.dataArray.email}
            cellPhone={props.dataArray.cellPhone}
            enrollmentPlan={props.dataArray.enrollmentPlan}
            totalDebt={props.dataArray.totalDebt}
            taxDebtType={props.dataArray.taxDebtType}
            taxDebtKind={props.dataArray.taxDebtKind}
            grossMonthlyIncome={props.dataArray.grossMonthlyIncome}
            creditScore={props.dataArray.creditScore}
            unfiledTaxReturns={props.dataArray.unfiledTaxReturns}
          />
        )
      case 13:
        return (
          <Contact />
        )

      default:
      // do nothing
    }
  }

//currently used but all steps in TAA

  return (
    <div className="relative max-w-xl mx-auto p-4 md:p-6 text-gray-900">
      {/* Progress Bar */}
      <div className="w-full h-2 bg-gray-200 rounded-t-md overflow-hidden">
        <div
          className="h-full bg-blue-400 transition-all duration-300"
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>

      {/* Card */}
      <div className="bg-white rounded-lg shadow drop-shadow-2xl">
        {steps()}
      </div>
    </div>
  )
}
